import { PRODUCT } from "@/constants";

const defaultValues = {
  avanti: { background: "bg-[#ffffff]/50", textColor: "#2E2D2C" },
  staysure: { background: "bg-[#000000]/20", textColor: "white" },
};

const brand: "staysure" | "avanti" =
  (PRODUCT as "staysure" | "avanti") ?? "staysure";

const defaqtoStyles = defaultValues[brand];

export default defaqtoStyles;
